import Vue from "vue";
import { withTenant } from "./AuthHeader";
import { env } from "../config/env";

const apiUrl = env.CLINIC_API_URL + "/empresa";

class CompanyService {
  find(tenant) {
    return Vue.prototype.$axios.get(apiUrl + "/byTenant", {
      headers: withTenant(tenant)
    });
  }
}

export default new CompanyService();
